import WebApi from "@/views/loyalty/shared/modules/web_api"

export class EncodeEndpointService {
    constructor (url) {
        this.url = url || `${process.env.VUE_APP_LOYALTY_URL}api/encode/`
        this.webApi = new WebApi()
    }

    async encodeCustomerId (customerId) {
        return this.webApi.get(`${this.url}customer/${customerId}`)
    }

    async encodeUserNumber (userNumber) {
        return this.webApi.get(`${this.url}user/${userNumber}`)
    }
}
